import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { CookieConsent } from "@/components/CookieConsent";
import Index from "./pages/Index";
import AboutMysticForest from "./pages/AboutMysticForest";
import Blog from "./pages/Blog";
import NotFound from "./pages/NotFound";
import Auth from "./pages/Auth";
import Admin from "./pages/Admin";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import FamilyRetreat from "./pages/experiences/FamilyRetreat";
import MensCircle from "./pages/experiences/MensCircle";
import CompanyWorkshop from "./pages/experiences/CompanyWorkshop";
import YogaRetreat from "./pages/experiences/YogaRetreat";
import DigitalDetox from "./pages/experiences/DigitalDetox";
import DigitalDetoxArticle from "./pages/articles/DigitalDetox";
import SlowLifeArticle from "./pages/articles/SlowLife";
import PowerOfNatureArticle from "./pages/articles/PowerOfNature";
import BreathRegenerationArticle from "./pages/articles/BreathRegeneration";
import RelationshipsWithoutScreensArticle from "./pages/articles/RelationshipsWithoutScreens";
import BurnoutEpidemicArticle from "./pages/articles/BurnoutEpidemic";
import MindfulnessDailyArticle from "./pages/articles/MindfulnessDaily";
import PowerOfRitualsArticle from "./pages/articles/PowerOfRituals";
import FoodAsCareArticle from "./pages/articles/FoodAsCare";
import OfflineTimeChildrenArticle from "./pages/articles/OfflineTimeChildren";
import WhyWeNeedCommunityArticle from "./pages/articles/WhyWeNeedCommunity";
import SilenceAbsenceNoiseArticle from "./pages/articles/SilenceAbsenceNoise";
import DigitalMinimalismArticle from "./pages/articles/DigitalMinimalism";
import RomoReliefArticle from "./pages/articles/RomoRelief";
import OverstimulationArticle from "./pages/articles/Overstimulation";
import ArtOfDoingOneThingArticle from "./pages/articles/ArtOfDoingOneThing";
import OfflineGatheringsArticle from "./pages/articles/OfflineGatherings";
import LostArtOfWalkingArticle from "./pages/articles/LostArtOfWalking";
import ShadowSideGoodVibesArticle from "./pages/articles/ShadowSideGoodVibes";
import ReturningToWaldenArticle from "./pages/articles/ReturningToWalden";
import SlowParentingArticle from "./pages/articles/SlowParenting";
import ScienceOfStillnessArticle from "./pages/articles/ScienceOfStillness";
import TwoLittleSavagesArticle from "./pages/articles/TwoLittleSavages";
import WhenMoreIsNoLongerEnough from "./pages/articles/WhenMoreIsNoLongerEnough";
import AuthenticExperiences from "./pages/articles/AuthenticExperiences";
import GeographyOfWonder from "./pages/articles/GeographyOfWonder";
import HarmonyNotRejection from "./pages/articles/HarmonyNotRejection";
import ShinrinYoku from "./pages/experiences/ShinrinYoku";
import HandpanWorkshop from "./pages/experiences/HandpanWorkshop";
import SlowCooking from "./pages/experiences/SlowCooking";
import MensRetreat from "./pages/experiences/MensRetreat";
import WomensRetreat from "./pages/experiences/WomensRetreat";
import BrandKit from "./pages/BrandKit";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <HelmetProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <CookieConsent />
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/about-mystic-forest" element={<AboutMysticForest />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/blog/digital-detox" element={<DigitalDetoxArticle />} />
          <Route path="/blog/slow-life" element={<SlowLifeArticle />} />
          <Route path="/blog/power-of-nature" element={<PowerOfNatureArticle />} />
          <Route path="/blog/breath-regeneration" element={<BreathRegenerationArticle />} />
          <Route path="/blog/relationships-without-screens" element={<RelationshipsWithoutScreensArticle />} />
          <Route path="/blog/burnout-epidemic" element={<BurnoutEpidemicArticle />} />
          <Route path="/blog/mindfulness-daily" element={<MindfulnessDailyArticle />} />
          <Route path="/blog/power-of-rituals" element={<PowerOfRitualsArticle />} />
          <Route path="/blog/food-as-care" element={<FoodAsCareArticle />} />
          <Route path="/blog/offline-time-children" element={<OfflineTimeChildrenArticle />} />
          <Route path="/blog/why-we-need-community" element={<WhyWeNeedCommunityArticle />} />
          <Route path="/blog/silence-absence-noise" element={<SilenceAbsenceNoiseArticle />} />
          <Route path="/blog/digital-minimalism" element={<DigitalMinimalismArticle />} />
          <Route path="/articles/digital-minimalism" element={<DigitalMinimalismArticle />} />
          <Route path="/articles/romo-relief" element={<RomoReliefArticle />} />
          <Route path="/articles/overstimulation" element={<OverstimulationArticle />} />
          <Route path="/articles/offline-gatherings" element={<OfflineGatheringsArticle />} />
          <Route path="/articles/lost-art-of-walking" element={<LostArtOfWalkingArticle />} />
          <Route path="/blog/art-of-doing-one-thing" element={<ArtOfDoingOneThingArticle />} />
          <Route path="/blog/shadow-side-good-vibes" element={<ShadowSideGoodVibesArticle />} />
          <Route path="/blog/returning-to-walden" element={<ReturningToWaldenArticle />} />
          <Route path="/blog/slow-parenting" element={<SlowParentingArticle />} />
          <Route path="/blog/science-of-stillness" element={<ScienceOfStillnessArticle />} />
          <Route path="/blog/two-little-savages" element={<TwoLittleSavagesArticle />} />
          <Route path="/blog/when-more-is-no-longer-enough" element={<WhenMoreIsNoLongerEnough />} />
          <Route path="/blog/authentic-experiences" element={<AuthenticExperiences />} />
          <Route path="/blog/geography-of-wonder" element={<GeographyOfWonder />} />
          <Route path="/blog/harmony-not-rejection" element={<HarmonyNotRejection />} />
          <Route path="/experiences/family-retreat" element={<FamilyRetreat />} />
          <Route path="/experiences/mens-circle" element={<MensCircle />} />
          <Route path="/experiences/company-workshop" element={<CompanyWorkshop />} />
          <Route path="/experiences/yoga-retreat" element={<YogaRetreat />} />
          <Route path="/experiences/digital-detox" element={<DigitalDetox />} />
          <Route path="/experiences/shinrin-yoku" element={<ShinrinYoku />} />
          <Route path="/experiences/handpan-workshop" element={<HandpanWorkshop />} />
          <Route path="/experiences/slow-cooking" element={<SlowCooking />} />
          <Route path="/experiences/mens-retreat" element={<MensRetreat />} />
          <Route path="/experiences/womens-retreat" element={<WomensRetreat />} />
          <Route path="/brand-kit" element={<BrandKit />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </HelmetProvider>
  </QueryClientProvider>
);

export default App;
